import { baseUrl } from "../../../../utils";

export const triggers = [
    {
        name: 'By Handle',
        label: 'Enter Handle',
        icon: `${baseUrl('icons/svg-icons/handle.svg')}`,
        triggerType: 1,
        isUpgrade: false,
    },
    {
        name: 'By Hashtag',
        label: 'Enter Hashtag',
        icon: `${baseUrl('icons/svg-icons/hashtag.svg')}`,
        triggerType: 1,
        isUpgrade: false,
    },
    {
        name: 'Social Network',
        label: 'Pick the preferred network',
        icon: `${baseUrl('icons/svg-icons/connections.svg')}`,
        triggerType: 2,
        isUpgrade: false,
    },
    {
        name: 'Media Type',
        label: 'Pick one or more assets',
        icon: `${baseUrl('icons/svg-icons/media-1.svg')}`,
        triggerType: 2,
        isUpgrade: false,
    },
    {
        name: 'By Feeds',
        label: 'Select your preferred feed type',
        icon: `${baseUrl('icons/svg-icons/feeds.svg')}`,
        triggerType: 2,
        isUpgrade: false,
    },
    {
        name: 'AI-Recommendation',
        label: 'Select your preferred AI recommendation',
        icon: `${baseUrl('icons/svg-icons/ai.svg')}`,
        triggerType: 2,
        isUpgrade: true,
    },
    {
        name: 'Tags',
        label: 'Select the desired tag',
        icon: `${baseUrl('icons/svg-icons/tags.svg')}`,
        triggerType: 3,
        isUpgrade: false,
    },
    {
        name: 'Language',
        label: 'Select the desired Language',
        icon: `${baseUrl('icons/svg-icons/language.svg')}`,
        triggerType: 3,
        isUpgrade: false,
    },
    {
        name: 'Duplicate Post',
        label: 'Remove duplicate post',
        icon: `${baseUrl('icons/svg-icons/duplicate.svg')}`,
        triggerType: 4,
        isUpgrade: false,
    },
    {
        name: 'By Keyword',
        label: 'Enter Keyword',
        icon: `${baseUrl('icons/svg-icons/text.svg')}`,
        triggerType: 1,
        isUpgrade: false,
    },
    {
        name: 'Sentiment',
        label: 'Pick your sentiment score analysis',
        icon: `${baseUrl('icons/svg-icons/sentiment.svg')}`,
        triggerType: 2,
        isUpgrade: true,
    }

]

export const defaultRules = [
    {
        name: 'Bye-bye Duplicates :',
        description: `Enable this AI-powered rule to hide repetitive posts cluttering your feed. Activate TruSense's Hide Duplicate Posts feature to filter out redundant content, ensuring a cleaner, streamlined experience.`,
        icon: `${baseUrl('icons/svg-icons/duplicates.svg')}`,
        value: false,
        isRuleUsed: false
    },
    {
        name: 'Negativity Neutralizer :',
        description: `Enable this AI-powered rule to detect and hide posts that give off a negative look for your brand automatically, keeping your feed focused on valuable posts.`,
        icon: `${baseUrl('icons/svg-icons/negativity.svg')}`,
        value: false,
        isRuleUsed: false
    },
    {
        name: 'Effortless Approval :',
        description: `Enable this rule to simplify your moderation process. TruSense's Auto-Approve recommended posts feature uses AI scores to surface only the best content.`,
        icon: `${baseUrl('icons/svg-icons/effortless.svg')}`,
        value: false,
        isRuleUsed: false
    }
]

export const rulesType = [
    {
        name: 'Public',
        type: 4,
        triggerType: 4,
        icon: `${baseUrl('icons/svg-icons/public.svg')}`
    },
    {
        name: 'Private',
        type: 4,
        triggerType: 4,
        icon: `${baseUrl('icons/svg-icons/private.svg')}`
    },
    {
        name: 'Delete',
        type: 5,
        triggerType: 4,
        icon: `${baseUrl('icons/svg-icons/delete.svg')}`
    },
    {
        name: 'Assign Tag',
        type: 3,
        triggerType: 3,
        icon: `${baseUrl('icons/svg-icons/tags.svg')}`,
    }
]